export const VERIFICATION_CODE_RESEND_BLOCK_TIMEOUT = 30; // SECONDS

export const VERIFICATION_CODE_RESEND_BUFFER_TIME = 2; // SECONDS

export const VERIFICATION_CODE_RESEND_BLOCK_TIMEOUT_WITH_BUFFER =
  VERIFICATION_CODE_RESEND_BLOCK_TIMEOUT + VERIFICATION_CODE_RESEND_BUFFER_TIME;

export const NICKNAME_MAX_LENGTH = 20;
